import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementCheckbox'], () => {
  return {
    $formkit: 'checkbox',
  }
})
